import React from 'react'
import {Button as ButtonChakra, useStyleConfig } from '@chakra-ui/react';


export function Button(props) {
    const { size, variant, ...rest } = props

    const styles = useStyleConfig("Button", { size, variant })
    return( < ButtonChakra sx = { styles } { ... rest } />)
  }